import { sk } from "../../../../date-fns/locale/sk.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    sk
  }
};